import { INSTALLMENT_TYPES, POLICY_REVIEW_STATES } from '../../resources/enums';
import { ICustomerPayments } from '../../resources/interfaces';
import { Applicant } from '../applicant/Applicant';
import HomeQuote from './HomeQuote';
import { IHomePolicy, IHomeQuote } from './IHomePolicy';

export class HomePolicy {
  policyNumber?: string;
  // socialPlatformIdentifier: string;
  insuranceType?: string;
  type: string;
  wallDetails: string;
  roofDetails: string;
  alwaysOccupied: boolean;
  hasOtherInsurance: boolean;
  mortgageLoan: boolean;
  reasonForAlwaysOccupied: string;
  reasonForMortgageLoan: string;
  reasonForOtherInsurance: string;
  buildingForResidentialPurpose: boolean;
  businessDoneInBuilding: boolean;
  hasAgreed: boolean;
  hasInsuranceInPastFiveYears: boolean;
  hasFireOrBurglaryInPastFiveYears: boolean;
  hasInsuranceCancelledOrPremiumIncreased: boolean;
  previousClaimInPastFiveYears: boolean;
  quote: HomeQuote;
  ref: string;
  createdOn: Date | undefined;
  startDate: Date | undefined;
  expiresOn: Date | undefined;
  applicant: Applicant;
  installmentType: INSTALLMENT_TYPES | undefined;
  reviewStage: POLICY_REVIEW_STATES;
  midReference: string;
  payments?: ICustomerPayments[];

  constructor(Imodel: IHomePolicy) {
    this.ref = Imodel.policyNumber ?? '';
    this.policyNumber = Imodel.policyNumber;
    this.createdOn = Imodel.createdOn ? new Date(Imodel.createdOn) : undefined;
    this.startDate = Imodel.startsOn ? new Date(Imodel.startsOn) : undefined;
    this.expiresOn = Imodel.expiresOn ? new Date(Imodel.expiresOn) : undefined;
    this.installmentType = Imodel.installmentType;
    this.quote = new HomeQuote(Imodel.homeQuote);

    this.applicant = new Applicant({
      address: Imodel.address ?? Imodel?.customer?.address,
      occupation: Imodel.occupation ?? Imodel?.customer?.occupation,
      phoneNumber: Imodel.phone ?? Imodel?.customer?.phone,
      email: Imodel?.email,
      firstName: Imodel?.firstName ?? Imodel?.customer?.firstName,
      lastName: Imodel?.lastName ?? Imodel?.customer?.lastName,
      // otherName: Imodel?.otherName,
      dateOfBirth: Imodel?.dateOfBirth ?? Imodel?.customer?.dateOfBirth,
      idType: Imodel.idType ?? Imodel?.customer?.idType,
      idNumber: Imodel.idNumber ?? Imodel?.customer?.idNumber,
      idExpiryDate: Imodel.idExpiryDate ?? Imodel?.customer?.idNumber,
      employerName: Imodel.employerName ?? Imodel?.customer?.employerName,
      employerAddress: Imodel.employerAddress ?? Imodel?.customer?.employerAddress,
      employerPhoneNumber: Imodel?.employerPhone ?? Imodel?.customer?.employerPhone,
      socialMedia: Imodel.socialPlatform ?? Imodel?.customer?.socialPlatform,
      gender: Imodel.gender ?? Imodel?.customer?.gender
      // businessNumber: Imodel.businessNumber,
      // businessAddress: Imodel.businessAddress,
      // position: Imodel.position,
      // digitalAddress: Imodel.digitalAddress
    });

    this.type = Imodel.type;
    this.wallDetails = Imodel.wallDetails;
    this.roofDetails = Imodel.roofDetails;
    this.alwaysOccupied = Imodel.alwaysOccupied;
    this.hasOtherInsurance = Imodel.hasOtherInsurance;
    this.mortgageLoan = Imodel.mortgageLoan;
    this.reasonForAlwaysOccupied = Imodel.reasonForAlwaysOccupied;
    this.reasonForMortgageLoan = Imodel.reasonForMortgageLoan;
    this.reasonForOtherInsurance = Imodel.reasonForMortgageLoan;
    this.buildingForResidentialPurpose = Imodel.buildingForResidentialPurpose;
    this.businessDoneInBuilding = Imodel.businessDoneInBuilding;
    this.hasAgreed = Imodel.hasAgreed;
    this.hasInsuranceInPastFiveYears = Imodel.hasInsuranceInPastFiveYears;
    this.hasFireOrBurglaryInPastFiveYears = Imodel.hasFireOrBurglaryInPastFiveYears;
    this.hasInsuranceCancelledOrPremiumIncreased = Imodel.hasInsuranceCancelledOrPremiumIncreased;
    this.previousClaimInPastFiveYears = Imodel.previousClaimInPastFiveYears;
    this.reviewStage = Imodel.reviewStage as POLICY_REVIEW_STATES;
    this.midReference = Imodel.midReference;
    this.payments = Imodel.payments??[];
  }

  isFullPayment(): boolean {
    return this.installmentType === 'FULL_PAYMENT';
  }

  isWeeklyInstallment(): boolean {
    return this.installmentType === 'TWELVE_WEEKS';
  }

  isPersonalDetailsProvided(): boolean {
    let isAllValid = false;

    if (this.isFullPayment()) {
      if (
        this.applicant?.phoneNumber &&
        this.applicant?.email &&
        this.applicant?.address &&
        this.applicant?.occupation
      ) {
        isAllValid = true;
      }
    } else {
      if (
        this.applicant?.phoneNumber &&
        this.applicant?.address &&
        this.applicant?.dateOfBirth &&
        this.applicant?.idType &&
        this.applicant?.idNumber &&
        this.applicant?.idExpiryDate &&
        this.applicant?.email &&
        this.applicant?.occupation &&
        (this.applicant?.occupation === 'Unemployed' ||
          (this.applicant?.occupation !== 'Unemployed' &&
            this.applicant?.employerName &&
            this.applicant?.employerAddress &&
            this.applicant?.employerPhoneNumber))
        // &&this.applicant?.monthlyIncome
      ) {
        isAllValid = true;
      }
    }

    return isAllValid;
  }

  isPaySmallSmallDetailsProvided(): boolean {
    let isAllValid = false;

    if (this.isFullPayment()) {
      if (this.applicant?.phoneNumber && this.applicant?.address && this.applicant?.occupation) {
        isAllValid = true;
      }
    } else {
      if (
        this.applicant?.phoneNumber &&
        this.applicant?.address &&
        this.applicant?.occupation &&
        this.applicant?.dateOfBirth &&
        this.applicant?.idType &&
        this.applicant?.idNumber &&
        this.applicant?.idExpiryDate
        // &&this.applicant?.monthlyIncome
      ) {
        isAllValid = true;
      }
    }

    return isAllValid;
  }

  isAllDetailsProvided(): boolean {
    return this.isPersonalDetailsProvided();
  }

  isAutoPolicy = (): boolean => {
    return false;
  };

  getFirstUnpaidPayment(): ICustomerPayments | undefined {
    return this.payments?.find((payment: ICustomerPayments) => payment.paymentStatus !== "SUCCESS");
  }
}
